import { isEmpty } from '@intelligence/v3/utils/common';
import { getOptionText } from '@intelligence/utils/topchartsUtils';
import { LANGUAGE_CN, LANGUAGE_EN } from '@home/_config/config';
import { DATASOURCE_KEY_MAP } from '@intelligence/v3/_config/metrics/keyMap';
import { COMBINE_DATA_SOURCES_MAPPING } from '@intelligence/v3/_config/metrics/combine';

const getDataSourceName = (locale: string, dataSource: string, dataSourceName?: string): string => {
  if (!isEmpty(dataSourceName)) return dataSourceName!;
  const dataSourceData = COMBINE_DATA_SOURCES_MAPPING[dataSource] ?? {};
  const dataSourceNameData = dataSourceData?.dataSourceName;
  // @ts-ignore
  return getOptionText(locale, { textEN: dataSourceNameData?.en, textCN: dataSourceNameData?.cn });
};

export const GSD_DATASOURCE_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getDataSourceName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD),
  [LANGUAGE_CN]: getDataSourceName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD),
};

export const MSCIENCE_DATASOURCE_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getDataSourceName(LANGUAGE_EN, DATASOURCE_KEY_MAP.MSCIENCE),
  [LANGUAGE_CN]: getDataSourceName(LANGUAGE_CN, DATASOURCE_KEY_MAP.MSCIENCE),
};

export const NPD_DATASOURCE_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getDataSourceName(LANGUAGE_EN, DATASOURCE_KEY_MAP.NPD),
  [LANGUAGE_CN]: getDataSourceName(LANGUAGE_CN, DATASOURCE_KEY_MAP.NPD),
};

export const NEWZOO_DATASOURCE_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getDataSourceName(LANGUAGE_EN, DATASOURCE_KEY_MAP.NEWZOO),
  [LANGUAGE_CN]: getDataSourceName(LANGUAGE_CN, DATASOURCE_KEY_MAP.NEWZOO),
};
